import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ImageWithLoader } from 'app/components';
import { AsideEventDetails } from './styles';

const propTypes = {
  picture: PropTypes.string,
  title: PropTypes.string,
  shortDescription: PropTypes.string,
  isVisible: PropTypes.bool.isRequired
};

const defaultProps = {
  picture: null,
  title: '',
  shortDescription: null
};

const Aside = ({ picture, title, shortDescription, isVisible }) => {
  const [t] = useTranslation();
  shortDescription = shortDescription.replaceAll("&nbsp;", " ")
  return (
    <AsideEventDetails isVisible={isVisible}>
      {
        picture && (
          <ImageWithLoader type="cinema" imgSrc={picture} imgTitle={title} />
        )
      }
      <div className="s-entity-details__aside-inner">
        <p dangerouslySetInnerHTML={{ __html: shortDescription || t('movies.no_description') }} />
      </div>
    </AsideEventDetails>
  );
};

Aside.propTypes = propTypes;
Aside.defaultProps = defaultProps;
export default Aside;
